class NavigationController {
    navigateHome() {
        this.props.navigate('/dashboard');
    }

    navigateClients() {
        this.props.navigate('/dashboard/clients');
    }

    navigateLogin() {
        this.props.navigate('/');
    }

    navigateClient(id) {
        this.props.navigate(`/dashboard/clients/client?id=${id}`);
    }

    navigatePriceList(id) {
        this.props.navigate(`/dashboard/price/list?id=${id}`);
    }

    navigatePrices() {
        this.props.navigate('/dashboard/price');
    }

    navigateSegmentList(id) {
        this.props.navigate(`/dashboard/segments/segment?id=${id}`);
    }

    navigateSegments() {
        this.props.navigate('/dashboard/segments');
    }

    navigatePromoter(id) {
        this.props.navigate(`/dashboard/trade/promoter?id=${id}`);
    }

    navigateStoreCheck(id) {
        this.props.navigate(`/dashboard/storeCheck?id=${id}`);
    }

    navigateAuditor(id) {
        this.props.navigate(`/dashboard/trade/auditor?id=${id}`);
    }

    navigateCampaign(id) {
        this.props.navigate(`/dashboard/trade/campaigns/campaign?id=${id}`);
    }

    navigateContract(id) {
        this.props.navigate(`/dashboard/trade/contracts/contract?id=${id}`);
    }

    navigateStore(id) {
        this.props.navigate(`/dashboard/stores/store?id=${id}`);
    }
}

export default NavigationController;
